// istanbul ignore file
import { applySavedPaymentMethod } from 'payments/hooks/usePaymentForm';
import type { PartialSaveOptions } from 'payments/types/form';
import { useSaveCardOnFileMutation } from 'reservations/payments/queries/useSaveCardOnFileMutation';

export const useSubmitSavedPaymentMethod = (
  handleSuccess: () => void,
  handle409Error?: () => void
) => {
  const saveCardOnFileMutation = useSaveCardOnFileMutation(
    handleSuccess,
    handle409Error
  );

  return (payload: PartialSaveOptions) => {
    const { savedPaymentMethod = '' } = payload;
    if (!savedPaymentMethod) {
      throw new Error();
    }

    applySavedPaymentMethod()(payload, formData => {
      saveCardOnFileMutation.mutate(formData);
    });
  };
};
